/**
 * OVERRIDE View.jsx
 * REASON: To add new display options to the listing block.
 */

import ListingBodyView from '../../../../../../components/Blocks/Listing/ListingBodyView';

export default ListingBodyView;